'use client';
import React, { useState } from 'react';
import IntegrationCards from './IntegrationCards';
import ApiKeyPanel from './ApiKeyPanel';
import WebhookPanel from './WebhookPanel';
import SyncLogPanel from './SyncLogPanel';

type SettingsTab = 'integrations' | 'api' | 'webhooks' | 'sync-log';

const tabs: { key: SettingsTab; label: string }[] = [
  { key: 'integrations', label: 'Connected Apps' },
  { key: 'api', label: 'API Keys' },
  { key: 'webhooks', label: 'Webhooks' },
  { key: 'sync-log', label: 'Sync Log' },
];

export default function IntegrationSettingsView() {
  const [activeTab, setActiveTab] = useState<SettingsTab>('integrations');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-zinc-100">Integration Settings</h1>
        <p className="text-sm text-zinc-500 mt-0.5">Connect FleetJockey with ServiceJockey, RigJockey, or configure standalone operation</p>
      </div>

      {/* Tab nav */}
      <div className="flex items-center gap-1 border-b border-zinc-800">
        {tabs.map((tab) => (
          <button
            key={`settings-tab-${tab.key}`}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2.5 text-sm font-medium transition-all border-b-2 -mb-px ${activeTab === tab.key ? 'border-amber-500 text-amber-400' : 'border-transparent text-zinc-500 hover:text-zinc-300'}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'integrations' && <IntegrationCards />}
      {activeTab === 'api' && <ApiKeyPanel />}
      {activeTab === 'webhooks' && <WebhookPanel />}
      {activeTab === 'sync-log' && <SyncLogPanel />}
    </div>
  );
}